module.exports = __webpack_public_path__ + "img/work-area.1e75f373.svg";